
export default {

  props: ["element", "maxWidth"],
  name: "hyperLinks",
};
